export default { 
    title: 'Radicaciones',
    addSettlementShortLabel: 'Nueva',
    addSettlement: 'Crear radicación',
    filterLabel: 'Filtrar por',
    resultLabel: '{result} resultado | {result} resultados',
    lastUpdateLabel: 'Última actualización: {datetime}',
    orderLabel: 'Ordenar por',
    loadingDataLabel: 'Obteniendo Radicaciones',
    emptyDataLabel: 'No se encontraron resultados',
    tryAgainLabel: 'Intente buscando otro término o ',
    paginationSizeLabel: 'Resultados/página',
    cleanFilters: 'limpiando los filtros',
    filtersAppliedLabel: ' aplicados',
    status: {
        inProgress: 'En progreso',
        completed: 'Pagado',
        sentToSponsor: 'Enviado',
        rejectedBySponsor: 'Rechazado',
        approvedBySponsor: 'Aprobado',
        error: 'Error'
    },
    filters: {
        status: 'Estado',
        sponsor: 'Aseguradora',
        from: 'Desde',
        to: 'Hasta',
        searchCode: 'Buscar por ID',
        dateRange: 'Rango de fechas',
    },
    settlementGrid: {
        code: 'ID Radicación',
        createdAt: 'Fecha de creación',
        sponsor: 'Aseguradora',
        amount: 'Monto a cobrar',
        authorizations: 'Autorizaciones',
        status: 'Estado'
    },
    sponsors: {
        DO: {
            humano: 'Humano Seguros',
            universal: 'ARS Universal',
            primera: 'ARS primera'
        }
    }
}
